/*
  Le comportement des pages écrites à la main.

  POURQUOI CE FICHIER EXISTE. Les pages « À propos », « Développement durable »
  et leurs voisines ont été composées en HTML et CSS directement dans le
  contenu de la page, côté Shopify. Le balisage et les styles y survivent, mais
  pas le JavaScript : l'éditeur de page le retire à l'enregistrement. Résultat,
  le lecteur audio affichait un bouton qui ne jouait rien, et les onglets un
  jeu d'onglets qui ne changeait rien.

  Le code est donc ici, dans le thème, où personne ne le nettoie. Il ne fait
  rien tant qu'il ne trouve pas le balisage correspondant : sur les pages qui
  n'ont ni lecteur ni onglets, il se termine en quelques microsecondes.

  Il ne remplace aucun balisage et n'écrit aucun style. Tout ce qu'il fait,
  c'est ajouter et retirer la classe « on », mettre à jour deux compteurs de
  temps, et une largeur en pourcentage. Si vous modifiez le HTML d'une page,
  gardez simplement les identifiants et les classes utilisés ci-dessous.
*/
(function () {
  'use strict';

  /* ─────────────────────────────────────────────── Le lecteur audio ───
     Balisage attendu, tel qu'il est déjà dans vos pages :

       .ag-audio
         audio#agAudioEl
         button#agPlayBtn      svg#agPlayIcon + svg#agPauseIcon
         span#agCurrent  span#agDuration
         #agBar > #agBarFill + #agBarDot

     Le fichier est en preload="metadata" : sa durée n'est connue qu'une fois
     l'en-tête reçu, d'où l'affichage différé du temps total.
  */
  function lecteurAudio() {
    var audio = document.getElementById('agAudioEl');
    var bouton = document.getElementById('agPlayBtn');
    if (!audio || !bouton) return;

    var iconePlay = document.getElementById('agPlayIcon');
    var iconePause = document.getElementById('agPauseIcon');
    var affCourant = document.getElementById('agCurrent');
    var affDuree = document.getElementById('agDuration');
    var barre = document.getElementById('agBar');
    var remplissage = document.getElementById('agBarFill');
    var point = document.getElementById('agBarDot');

    function mmss(s) {
      if (!isFinite(s) || s < 0) return '0:00';
      var m = Math.floor(s / 60);
      var r = Math.floor(s % 60);
      return m + ':' + (r < 10 ? '0' : '') + r;
    }

    function montrerIcone(enLecture) {
      if (iconePlay) iconePlay.style.display = enLecture ? 'none' : '';
      if (iconePause) iconePause.style.display = enLecture ? '' : 'none';
      bouton.setAttribute('aria-label', enLecture ? 'Mettre en pause' : 'Écouter');
      bouton.setAttribute('aria-pressed', enLecture ? 'true' : 'false');
    }

    function majBarre() {
      var d = audio.duration;
      var p = (isFinite(d) && d > 0) ? (audio.currentTime / d) * 100 : 0;
      if (remplissage) remplissage.style.width = p + '%';
      if (point) point.style.left = p + '%';
      if (affCourant) affCourant.textContent = mmss(audio.currentTime);
    }

    /* Le bouton n'a pas de type : dans un formulaire il vaudrait « submit »
       et rechargerait la page. On le fixe, par précaution. */
    bouton.setAttribute('type', 'button');
    montrerIcone(false);

    bouton.addEventListener('click', function () {
      if (audio.paused) {
        var p = audio.play();
        /* Un navigateur peut refuser la lecture (onglet en sourdine, économie
           d'énergie). On ne laisse pas l'icône mentir dans ce cas. */
        if (p && typeof p.catch === 'function') p.catch(function () { montrerIcone(false); });
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () { montrerIcone(true); });
    audio.addEventListener('pause', function () { montrerIcone(false); });
    audio.addEventListener('ended', function () {
      montrerIcone(false);
      audio.currentTime = 0;
      majBarre();
    });
    audio.addEventListener('timeupdate', majBarre);
    audio.addEventListener('loadedmetadata', function () {
      if (affDuree) affDuree.textContent = mmss(audio.duration);
      majBarre();
    });

    /* Se déplacer dans le morceau, à la souris comme au doigt. */
    if (barre) {
      barre.setAttribute('role', 'slider');
      barre.setAttribute('tabindex', '0');
      barre.setAttribute('aria-label', 'Position dans le morceau');

      var glisse = false;

      function versPosition(clientX) {
        var r = barre.getBoundingClientRect();
        if (!r.width || !isFinite(audio.duration)) return;
        var t = (clientX - r.left) / r.width;
        audio.currentTime = Math.max(0, Math.min(1, t)) * audio.duration;
        majBarre();
      }

      barre.addEventListener('pointerdown', function (e) {
        glisse = true;
        barre.setPointerCapture && barre.setPointerCapture(e.pointerId);
        versPosition(e.clientX);
      });
      barre.addEventListener('pointermove', function (e) { if (glisse) versPosition(e.clientX); });
      barre.addEventListener('pointerup', function () { glisse = false; });
      barre.addEventListener('pointercancel', function () { glisse = false; });

      barre.addEventListener('keydown', function (e) {
        if (!isFinite(audio.duration)) return;
        if (e.key === 'ArrowLeft') { audio.currentTime = Math.max(0, audio.currentTime - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); e.preventDefault(); }
        if (e.key === ' ' || e.key === 'Enter') { bouton.click(); e.preventDefault(); }
      });
    }

    /* Si les métadonnées sont déjà là au moment où le script s'exécute. */
    if (audio.readyState >= 1 && affDuree) affDuree.textContent = mmss(audio.duration);
  }

  /* ────────────────────────────────────────────────────── Les onglets ───
     Balisage attendu :

       .ag-tabs > button.ag-tab   (l'actif porte « on »)
       puis, en frères qui suivent, autant de .ag-sec  (l'actif porte « on »)

     L'association se fait par rang : le premier onglet ouvre la première
     section, et ainsi de suite. C'est ce que fait déjà le HTML en place, où
     les sections portent des identifiants dans le désordre (s2, s4, s3) :
     c'est l'ordre d'écriture qui compte, pas le nom.
  */
  function onglets() {
    var groupes = document.querySelectorAll('.ag-tabs');
    Array.prototype.forEach.call(groupes, function (groupe) {
      var boutons = groupe.querySelectorAll('.ag-tab');
      if (!boutons.length) return;

      var sections = [];
      var n = groupe.nextElementSibling;
      while (n && sections.length < boutons.length) {
        if (n.classList.contains('ag-sec')) sections.push(n);
        n = n.nextElementSibling;
      }
      if (sections.length !== boutons.length) return;   /* balisage inattendu : on s'abstient */

      groupe.setAttribute('role', 'tablist');

      function activer(i) {
        Array.prototype.forEach.call(boutons, function (b, k) {
          b.classList.toggle('on', k === i);
          b.setAttribute('aria-selected', k === i ? 'true' : 'false');
          b.setAttribute('tabindex', k === i ? '0' : '-1');
        });
        sections.forEach(function (s, k) {
          s.classList.toggle('on', k === i);
          s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        });
      }

      Array.prototype.forEach.call(boutons, function (b, i) {
        b.setAttribute('type', 'button');
        b.setAttribute('role', 'tab');
        b.addEventListener('click', function () { activer(i); });
        b.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          var j = (i + d + boutons.length) % boutons.length;
          boutons[j].focus();
          activer(j);
          e.preventDefault();
        });
      });

      /* On respecte l'onglet déjà marqué « on » dans le HTML. */
      var depart = 0;
      Array.prototype.forEach.call(boutons, function (b, i) { if (b.classList.contains('on')) depart = i; });
      activer(depart);
    });
  }

  function demarrer() {
    lecteurAudio();
    onglets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();